module.exports = __webpack_public_path__ + "static/mobile_x86_qrcode.df2c7050.png";